/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillaryDistributionFormConfiguration,
    AncillaryDistributionFormConfigurationFromJSON,
    AncillaryDistributionFormConfigurationToJSON,
    AncillaryDistributionFormData,
    AncillaryDistributionFormDataFromJSON,
    AncillaryDistributionFormDataToJSON,
    AncillaryDistributionValidationData,
    AncillaryDistributionValidationDataFromJSON,
    AncillaryDistributionValidationDataToJSON,
} from '../models';

export interface ApiAncillaryDistributionFormConfigurationGetRequest {
    brand?: number;
    market?: string;
    supplier?: string;
    carrier?: string;
    ancillaryCategory?: number;
}

export interface ApiAncillaryDistributionFormCreatePostRequest {
    ancillaryDistributionFormData?: AncillaryDistributionFormData;
}

export interface ApiAncillaryDistributionFormDataGetRequest {
    id?: string;
}

export interface ApiAncillaryDistributionFormUpdatePostRequest {
    ancillaryDistributionFormData?: AncillaryDistributionFormData;
}

export interface ApiAncillaryDistributionFormValidatePostRequest {
    ancillaryDistributionFormData?: AncillaryDistributionFormData;
}

/**
 * no description
 */
export class AncillaryDistributionFormApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillaryDistributionFormConfigurationGetRaw(requestParameters: ApiAncillaryDistributionFormConfigurationGetRequest): Promise<runtime.ApiResponse<AncillaryDistributionFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        if (requestParameters.supplier !== undefined) {
            queryParameters['supplier'] = requestParameters.supplier;
        }

        if (requestParameters.carrier !== undefined) {
            queryParameters['carrier'] = requestParameters.carrier;
        }

        if (requestParameters.ancillaryCategory !== undefined) {
            queryParameters['ancillaryCategory'] = requestParameters.ancillaryCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryDistributionFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryDistributionFormConfigurationGet(requestParameters: ApiAncillaryDistributionFormConfigurationGetRequest): Promise<AncillaryDistributionFormConfiguration> {
        const response = await this.apiAncillaryDistributionFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillaryDistributionFormCreatePostRaw(requestParameters: ApiAncillaryDistributionFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryDistributionFormDataToJSON(requestParameters.ancillaryDistributionFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillaryDistributionFormCreatePost(requestParameters: ApiAncillaryDistributionFormCreatePostRequest): Promise<void> {
        await this.apiAncillaryDistributionFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillaryDistributionFormDataGetRaw(requestParameters: ApiAncillaryDistributionFormDataGetRequest): Promise<runtime.ApiResponse<AncillaryDistributionFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryDistributionFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryDistributionFormDataGet(requestParameters: ApiAncillaryDistributionFormDataGetRequest): Promise<AncillaryDistributionFormData> {
        const response = await this.apiAncillaryDistributionFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillaryDistributionFormUpdatePostRaw(requestParameters: ApiAncillaryDistributionFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryDistributionFormDataToJSON(requestParameters.ancillaryDistributionFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillaryDistributionFormUpdatePost(requestParameters: ApiAncillaryDistributionFormUpdatePostRequest): Promise<void> {
        await this.apiAncillaryDistributionFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillaryDistributionFormValidatePostRaw(requestParameters: ApiAncillaryDistributionFormValidatePostRequest): Promise<runtime.ApiResponse<AncillaryDistributionValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryDistributionFormDataToJSON(requestParameters.ancillaryDistributionFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryDistributionValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryDistributionFormValidatePost(requestParameters: ApiAncillaryDistributionFormValidatePostRequest): Promise<AncillaryDistributionValidationData> {
        const response = await this.apiAncillaryDistributionFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
